import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api/api';
import { Button } from 'rmwc/Button';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';
import { Grid, GridCell } from 'rmwc/Grid';
import StatusMessage from '../../util/StatusMessage';

class AdminUserImport extends Component {

	constructor(props){
		super(props) 
		this.state = {
		}
	}

	handleRendering(e, urlInput, type, certificationType, uploadType){

		if (urlInput === 'upload') {
			this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${uploadType}`)
		}

		else if(urlInput === 'view') {
			this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${certificationType}/${uploadType}`)
		}
	}

	handleUserDetails = (e) => {
		this.props.history.push('/portal/app/reg_user_details')
	}

	render(){
		return(
			<div>
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<Typography use="headline6">User Import </Typography> 
							<GridCell span="12">
								<Typography use="headline7" onClick={(e) => this.handleRendering(e,"upload","new", '', "userImport")} style={{color: 'blue',textDecorationLine: 'underline'}}> Import New </Typography>
							</GridCell>
							<GridCell span="6">
                	<Typography use="caption">Info: Column Names as follows: email, mobile, first name, last name, country code</Typography>
              </GridCell>
              <GridCell span="12">
								<Typography use="headline7" onClick={(e) => this.handleRendering(e,"view", 'history', 0, "userImport")} style={{color: 'blue',textDecorationLine: 'underline'}}> View Upload History </Typography>
							</GridCell>
						</Card>
						<br/>
						<br/>
						<Card style={{padding: '25px'}}>
							<Typography use="headline6">User Upload Details</Typography> 
							<GridCell span="12">
								<Typography use="headline7" onClick={this.handleUserDetails} style={{color: 'blue',textDecorationLine: 'underline'}}> View User Details </Typography>
							</GridCell>
						</Card>
					</GridCell>
				</Grid>
			</div>
			)
	}

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserImport);


// WEBPACK FOOTER //
// ./src/views/admin/AdminUserImport.jsx